module.exports = __webpack_public_path__ + "static/media/badge-dollar.7eb8b390.svg";